export default __webpack_public_path__ + "static/media/instagram.c25174ab.svg";